import { t } from "i18next";
import { useState } from "react";
import { validateNumericInput } from "utils/security";

export default function ThirdStep({
  bars = [],
  formState,
  setFormState,
}) {
  const [showMoreBars, setShowMoreBars] = useState(false);

  return (
    <div className="w-full">
      {/* Header Section */}

      {/* Form Content */}
      <div className="space-y-4 md:space-y-6">
        
        {/* Bars Section */}
        <div className="space-y-2">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-4 h-4 bg-green-100 rounded-full flex items-center justify-center">
              <svg className="w-2 h-2 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
            <h2 className="text-sm font-semibold text-gray-900">{t("signupBarsExplanation")}</h2>
          </div>

          <div className="space-y-3">
            {formState?.data?.bars
              .slice(0, showMoreBars ? bars.length : 3)
              .map((bar, index) => (
                <div key={index} className="bg-gray-50 rounded-lg p-3">
                  <div className="flex items-center justify-center mb-2">
                    <div className="w-full md:w-1/2 flex items-center justify-between">
                      <span className="text-xs font-medium text-gray-700 text-left">{bar.start}</span>
                      <span className="text-xs font-medium text-gray-700 text-right">{bar.end}</span>
                    </div>
                  </div>
                  
                  <div className="flex justify-center">
                    <div className="w-full md:w-1/2">
                      <input
                        type="range"
                        min="0"
                        max="10"
                        step="1"
                        value={bar.value}
                      onChange={(e) => {
                        const validation = validateNumericInput(e.target.value, 0, 10);
                        if (validation.isValid) {
                          setFormState((pre) => ({
                            ...pre,
                            data: {
                              ...pre.data,
                              bars: pre.data.bars.map((b, i) => {
                                if (i === index) {
                                  return {
                                    ...b,
                                    value: validation.sanitized,
                                  };
                                }
                                return b;
                              }),
                            },
                          }));
                        }
                      }}
                        className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer block [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:h-5 [&::-webkit-slider-thumb]:w-5 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-blue-600 [&::-webkit-slider-thumb]:cursor-pointer [&::-webkit-slider-thumb]:border-2 [&::-webkit-slider-thumb]:border-white [&::-webkit-slider-thumb]:shadow-md [&::-moz-range-thumb]:h-5 [&::-moz-range-thumb]:w-5 [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:bg-blue-600 [&::-moz-range-thumb]:cursor-pointer [&::-moz-range-thumb]:border-2 [&::-moz-range-thumb]:border-white [&::-moz-range-thumb]:shadow-md"
                        style={{
                          background: `linear-gradient(to right, #3b82f6 0%, #3b82f6 ${(bar.value / 10) * 100}%, #e5e7eb ${(bar.value / 10) * 100}%, #e5e7eb 100%)`,
                          width: '100%',
                          display: 'block'
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))}
          </div>

          {/* Show More/Less Button */}
          {bars.length > 3 && (
            <div className="flex justify-center w-full mt-2">
              <button
                onClick={() => setShowMoreBars((pre) => !pre)}
                className="flex items-center gap-1 px-3 py-1.5 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-all duration-200 text-xs font-medium"
              >
                <div className="w-4 h-4 bg-green-100 rounded-full flex items-center justify-center">
                  <span className="text-green-600 font-bold text-xs">
                    {showMoreBars ? "-" : "+"}
                  </span>
                </div>
                {showMoreBars ? t("signupLess") : t("signupMore")}
              </button>
            </div>
          )}
        </div>
      </div>

    </div>
  );
}